// extracted by mini-css-extract-plugin
export default {"details":"Ponude_details__4cwTO","posaljiPonudu":"Ponude_posaljiPonudu__OX1XO","table":"Ponude_table__b4+k+"};